import type { IAccount, IAppManagement, IAppManagementPayload } from '~/types/application-management'
import type { TPlatformType } from '~/types/device-type'

import config from '~/config'
import { request } from '~/utils/request'

/** APPLICATION */

export const getAppsManagerList = (): Promise<IAppManagement[]> => {
  return request({
    url: `${config.APP_MANAGEMENT_API}/apps`,
  })
}

export const setApp = (payload: IAppManagementPayload): Promise<IAppManagement> => {
  return request({
    data: payload,
    method: 'POST',
    url: `${config.APP_MANAGEMENT_API}/app-key/${payload.app_key}`,
  })
}

export const getAppDetails = (appKey: string): Promise<IAppManagement> => {
  return request({
    url: `${config.APP_MANAGEMENT_API}/app-key/${appKey}`,
  })
}

/** ACCOUNT */

export const getAccount = (accountKey: string): Promise<IAccount> => {
  return request({
    url: `${config.APP_MANAGEMENT_API}/account-key/${accountKey}`,
  })
}

export const updateAccount = (payload: IAccount): Promise<IAccount> => {
  return request({
    data: payload,
    method: 'PATCH',
    url: `${config.APP_MANAGEMENT_API}/account-key/${payload.account_key}`,
  })
}

/** SERVICES */

export const setService = ({
  additionalConfig,
  appKey,
  enabled,
  platform,
  service,
}: {
  additionalConfig: string
  appKey: string
  enabled: boolean
  platform: TPlatformType
  service: string
}): Promise<void> => {
  return request({
    data: {
      additional_config: additionalConfig,
      enabled,
      service,
    },
    method: 'POST',
    url: `${config.APP_MANAGEMENT_API}/service/app-key/${appKey}/device-type/${platform}`,
  })
}
